import { createContext } from "react";

let defaultUser = { isPublic: true };
sessionStorage.setItem("defaultUser", JSON.stringify(defaultUser));
export const UserContext = createContext(sessionStorage.getItem("user") ? sessionStorage.getItem("user") : defaultUser);
